import { Component, ElementRef, EventEmitter, HostListener, ViewContainerRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Configuration } from '../../shared/services/configuration';
import { HttpClientCustom } from '../../shared/services/http.client';
import { SharedData } from '../../shared/sharedData';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';
import { AddParentOrganizationComponent } from './addParentOrganization';


@Component({
    selector: 'organizationList',
    templateUrl: 'organizationList.html',
    outputs: ['updateRate: hideMe']
})

export class OrganizationPage {
    public updateRate: any = new EventEmitter();
    public page = 5;
    public endingPage = 0;
    public startingPage = 0;
    public asl: boolean = false;
    public showChild: boolean = false;
    public localState = { value: '' };
    public _baseUrl: any;
    public orgData: any = [];
    public trackHides = null;
    public primarySupervisorModel: any;
    public employeeCode: any;
    public showAdvanceSearch: any = false;
    public pageSize: any = 10;


    constructor(
        public route: ActivatedRoute,
        public modalService: NgbModal,
        public router: Router,
        public _global: Configuration,
        public http: HttpClientCustom,
        public eRef: ElementRef,
        public share: SharedData,
        public _sanitizer: DomSanitizer,
        public builder: FormBuilder,
        public _toaster: ToasterComponent,
        public translate: TranslateService,
        public vcr: ViewContainerRef) {
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.getOrgTree();

    }

    public getOrgtype() {
        if (this.orgData.orgTypeName == undefined) {
            return this.share.getMapValues('' + this.orgData.orgType + '');
        } else {
            return this.orgData.orgTypeName;
        }

    }

    public orgAdd() {
        this.share.saveData({ orgId: null, type: 'ADD' });
        const modalRef = this.modalService.open(AddParentOrganizationComponent)
            .result.then((result) => {
                this.addChildTree(result);
            }, (reason) => {
                ;
            });
    }

    public editOrg(param) {
        let self = this;
        this.share.saveData({ org: param, type: 'EDIT' });
        const modalRef = this.modalService.open(AddParentOrganizationComponent)
            .result.then((result) => {
                this.addToParent(result);
            }, (reason) => {
                ;
            });

    }

    public addOrganization() {
        this.share.saveData({ orgId: null, type: 'ADD' });
        this.router.navigate(['menu/addOrganization']);
    }

    public refreshLocal(param){
        this.getOrgTree(); 
    }

    public addSubLevels(evn) {
        this.asl = evn;
    }

    @HostListener('window:click', ['$event'])
    public clickOut(event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(() => {
                this.trackHides = null;
            }, 100);
        }
    }

    public clicked() {
        this.trackHides = null;
    }

    public showAdvanced(e) {
        this.showAdvanceSearch = e;
    }

    public getOrgTree() {
        try {
            let self = this;
            let url = self._baseUrl + 'v1/webAdmin/orgUnit/';
            self.http.get(url).subscribe((result) => {
                self.orgData = result.data;
            });
        } catch (e) {
            console.log('Org Tree error catch', e);
        }
    }

    public toggleChild() {
        this.showChild = !this.showChild;
    }

    public removeFromChild(id: number) {
        let self = this;
        let index;
        for (let i in self.orgData) {
            if (self.orgData[i].id === id) {
                index = i;
            }
        }
        self.orgData.splice(index, 1);
        self.translate.get('orgDeleted').subscribe((msg) => {
            self._toaster.showSuccess(msg);
        });

    }

    public addChildTree(event: any) {
        this.share.saveAsMap('' + event.data.orgType + '', event.orgTypeName);
        /* console.log("Org Data::",this.orgData)
        console.log("Event Data::",event.data)
        if (this.orgData != null) {
            this.orgData.push(event.data);
        } else {
            this.orgData = new Array(0);
            this.orgData.push(event.data);
        } */
        this.getOrgTree()
        this.translate.get('orgSaved').subscribe((msg) => {
            this._toaster.showSuccess(msg);
        });
    }

    public addToParent(event: any) {
        this.share.saveAsMap('' + event.data.orgType + '', event.orgTypeName);
        let parorgData = event.data;
        if (this.orgData != null) {
            for (let i in this.orgData) {
                if (this.orgData[i].id === parorgData.id) {
                    this.orgData[i] = parorgData;
                    break;
                }
            }
        } else {
            this.orgData = new Array(0);
            this.orgData.push(parorgData);
        }
        this.translate.get('orgUpdated').subscribe((msg) => {
            this._toaster.showSuccess(msg);
        });
        this.router.navigate(['menu/organizationList']);
    }

}



// WEBPACK FOOTER //
// ./src/app/tools/org/organizationList.ts